module.exports = __webpack_public_path__ + "img/ic_nav_back_white.148478f8.svg";